var render = function render(){var _vm=this,_c=_vm._self._c;return _c('k-breadcrumb',[_c('b-breadcrumb-item',{attrs:{"to":_vm.isSystemNested ? '' : _vm.homePath,"disabled":_vm.isSystemNested}},[_c('b-icon',{attrs:{"icon":"house-fill"}})],1),_vm._l((_vm.routeName),function(item){return _c('b-breadcrumb-item',{key:item.id,attrs:{"to":item.to,"active":item.active}},[_vm._v(" "+_vm._s(item.text)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }